<template>
  <div class="vz-individual-order-cargo pdf-order-section" :class="{'vz-individual-order-cargo-disabled': disabled}">
    <div class="vz-individual-order-cargo-title text-h1 color-light mb-20">
      Груз
    </div>
    <div class="vz-personal-order-blocks tiny-gap">
      <div class="vz-position-relative">
        <div v-if="disabled" class="disabled-card" />
        <div class="vz-individual-order-cargo-type flex">
          <vz-checkbox
            v-model="isTypeCargo"
            :disabled="disabled"
            label="Груз"
          />
          <vz-checkbox
            v-model="isTypeCorrespondence"
            :disabled="disabled"
            label="Корреспонденция"
          />
          <vz-tooltip-info
            class="vz-individual-order-cargo-tooltip"
          >
            <template #baloon>
              <span>{{ tooltip }}</span>
            </template>
          </vz-tooltip-info>
        </div>
        <div class="vz-individual-order-cargo-overlay-wrapper">
          <vz-switcher
            v-model="mode"
            :items="cargoTabs"
            big
            :disabled="(isOnlyCorrespondence || orderLock) && !isCloned"
            class="text-caption mt-10 vz-individual-order-cargo-switcher"
          />
          <keep-alive>
            <div class="flex flex-wrap">
              <component :is="cargoModesComponent" :order-lock="orderLock" @set-mode="mode = $event" />
            </div>
          </keep-alive>
          <div v-if="isOnlyCorrespondence" class="vz-individual-order-cargo-overlay" />
        </div>
      </div>
      <div class="vz-position-relative">
        <div v-if="disabled" class="disabled-card" />
        <vz-cargo-category :disabled="disabled" class="mb-20" />
        <vz-cargo-wrapping
          v-if="!isParcelsMode"
          :disabled="disabled"
        />
        <vz-cargo-insurance-transportation :order-lock="disabled" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {SwitchItem} from '~/types/types';
import VzCargoInsuranceTransportation
  from '~/components/personal/order/cargo/parts/vz-cargo-insurance-transportation.vue';
import {useOrderStore} from '~/stores/order';
import VzCargoWrapping from '~/components/personal/order/cargo/vz-cargo-wrapping.vue';
import useCargoBlock from '~/components/personal/order/cargo/useCargoBlock';
import VzCargoCategory from '~/components/personal/order/cargo/vz-cargo-category.vue';

const orderStore = useOrderStore()
const {
  tooltip, isTypeCorrespondence, isTypeCargo,
  mode, disabled, cargoModesComponent, isParcelsMode,
  orderLock, isOnlyCorrespondence, isCloned
} = useCargoBlock()

const cargoTabs: SwitchItem[] = [
  {
    title: 'Габариты',
    value: 'dimension'
  },
  {
    title: 'Места',
    value: 'places'
  },
  {
    title: 'Паллета',
    value: 'pallets'
  }
]
</script>
